export default "__VITE_ASSET__a027cd52__"